import React from "react";

import { cn } from "@/src/lib/utils";

interface AudioVideoFormatTagProps {
  children: React.ReactNode;
  isActive?: boolean;
}

function AudioVideoFormatTag({
  children,
  isActive,
}: AudioVideoFormatTagProps): React.JSX.Element {
  const tagClassNames = cn(
    "rounded border px-1 py-0.5 text-xs font-medium",
    isActive
      ? "border-primary/20 bg-primary/5 text-primary"
      : "border-border bg-muted text-subtle opacity-60",
  );
  return <div className={tagClassNames}>{children}</div>;
}

export default AudioVideoFormatTag;
